import { render } from "./monitoringSystem2.vue?vue&type=template&id=04363ff5&scoped=true"
import script from "./monitoringSystem2.vue?vue&type=script&lang=js"
export * from "./monitoringSystem2.vue?vue&type=script&lang=js"

import "./monitoringSystem2.vue?vue&type=style&index=0&id=04363ff5&lang=scss&scoped=true"

import exportComponent from "D:\\projects\\gitlab\\DemoLab\\DemoLab-data\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04363ff5"]])

export default __exports__